import { ReactNode } from 'react'

import styles from './PageHeading.module.scss'

export type HeadingLevel = 2 | 3

export function PageHeading({
  children,
  level = 3,
  className = '',
  ...rest
}: { children: ReactNode; level?: HeadingLevel; className?: string } & React.HTMLAttributes<HTMLHeadingElement>) {
  const Tag = level === 2 ? 'h2' : 'h3'
  return (
    <Tag className={`text-center ${styles.heading} ${className}`.trim()} {...rest}>
      {children}
    </Tag>
  )
}
